import React from 'react';
import { Card, Dropdown } from 'antd';

const IconCard = ({
  icon,
  title,
  subtitle,
  extraInfo = [],
  onClick,
  dropdownItems,
  dropdownTrigger
}) => {
  const cardExtra = dropdownItems ? (
    <Dropdown
      menu={{ items: dropdownItems }}
      trigger={['click']}
      placement="bottomRight"
      onClick={(e) => e.stopPropagation()}
    >
      {dropdownTrigger}
    </Dropdown>
  ) : null;

  return (
    <Card
      size="small"
      onClick={onClick}
      hoverable
      style={{ cursor: 'pointer' }}
      extra={cardExtra}
    >
      <div style={{ textAlign: 'center', padding: '8px 0' }}>
        {/* Icon */}
        <div style={{ fontSize: '24px', color: '#1890ff', marginBottom: '8px' }}>
          {icon}
        </div>

        {/* Title */}
        <div style={{ 
          fontWeight: 'bold',
          marginBottom: '4px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>
          {title}
        </div>

        {/* Subtitle */}
        {subtitle && (
          <div style={{ 
            fontSize: '12px',
            color: '#8c8c8c',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            {subtitle}
          </div>
        )}

        {/* Extra Info */}
        {extraInfo.map((info, index) => (
          <div
            key={index}
            style={{
              fontSize: '12px',
              color: '#8c8c8c',
              marginTop: '4px'
            }}
          >
            {info}
          </div>
        ))}
      </div>
    </Card>
  );
};

export default IconCard;
